<template>
  <div
    class="rounded bg-overlay2 pt-5 border-gray-400 border w-32 text-white flex flex-col text-center overflow-hidden"
  >
    <span
      class="font-medium text-xl uppercase font-oswald h-10 leading-none"
    >
      Overview
    </span>
    <button
      class="bg-gray-600 hover:bg-gray-roc transition duration-300 text-white text-base py-2 cursor-pointer w-full"
      @click="openBonuses"
    >
      Bonuses
    </button>
    <button
      class="bg-gray-600 hover:bg-gray-roc transition duration-300 text-white text-base py-2 cursor-pointer w-full border-gray-400 border-t"
      @click="openWonders"
    >
      Wonders
    </button>
    <button
      v-if="editable"
      class="bg-gray-600 hover:bg-gray-roc transition duration-300 text-white text-base py-2 cursor-pointer w-full border-gray-400 border-t"
      @click="openMuseum"
    >
      Museum
    </button>
  </div>
</template>

<script>
import {computed, onBeforeUnmount, onMounted, ref} from 'vue';
import {useLayoutStore} from '@/roc/stores/LayoutStore';
import ProductionOutputType from '@/roc/effects/Production/ProductionOutputType';
import {useWonderStore} from '@/roc/stores/WonderStore';
import {useMuseumStore} from '@/roc/stores/MuseumStore';
import {useApplicationStore} from '@/roc/stores/ApplicationStore';
import PassiveAura from '@/roc/effects/PassiveAura/PassiveAura';
import PassiveAuraType from '@/roc/effects/PassiveAura/PassiveAuraType';
import PassiveProduction from '@/roc/effects/Production/PassiveProduction';
import EraType from '@/roc/era/EraType';

export default {
  setup() {
    const wonderStore = useWonderStore();
    const museumStore = useMuseumStore();
    const appStore = useApplicationStore();

    return {
      editable: computed(() => {
        return appStore.editable;
      }),

      openWonders () {
        wonderStore.openWonderConfiguration();
      },

      openMuseum () {
        museumStore.openMuseumConfiguration();
      },

      openBonuses () {
        appStore.openBonuses();
      }
    };
  }
};
</script>
